import { FullWorkflow } from "@components/WorkflowCard/types";
import { StepType, WORKFLOW_TRIGGERS } from "@typings/api-models";

const triggerText = (workflow: FullWorkflow): string => {
  const triggerStep = workflow.steps.find((step) => step.type === StepType.TRIGGER);
  if (triggerStep?.eventName === WORKFLOW_TRIGGERS.PRODUCT_PURCHASED) {
    return 'On Purchase';
  }
  if (triggerStep?.eventName === WORKFLOW_TRIGGERS.CART_ABANDONED) {
    return 'On Cart Abandoned';
  }
  if (triggerStep?.eventName === WORKFLOW_TRIGGERS.UPCOMING_BOOKING) {
    return 'On Upcoming Booking';
  }
  return 'Add trigger';
};

export default triggerText;